export default {
  getPersonList(state) {
    return state.personList
  },
  getPerson(state){
    return state.person
  }
}
